import React from 'react';
import PropTypes from 'prop-types';

import BlockLabel from './block-label';

const leftAlign = {
  textAlign: 'left',
};

const padding20 = {
  padding: 20,
  height: 150,
};

const EngagementRate = props => {
  const { profile } = props;
  const { instagramEngagementRate } = profile;
  return (
    <div style={padding20}>
      <h2 style={leftAlign}>{instagramEngagementRate ? `${instagramEngagementRate}%` : '-'}</h2>
      <BlockLabel label="Engagement Rate" />
    </div>
  );
};

EngagementRate.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default EngagementRate;



// WEBPACK FOOTER //
// ./src/containers/summary/components/engagement-rate.js